import {
  Component, Input, ChangeDetectorRef,
  Optional, OnInit, ViewEncapsulation
} from '@angular/core';
import {Questionnaire} from '@ngmedax/common-questionnaire-types';
import {Translatable, TranslationService} from '@ngmedax/translation';
import {QuestionnaireEditorService} from '../../../services/questionnaire-editor.service';
import {QuestionnaireConditionService} from '../../../services/questionnaire-condition.service';
import {TRANSLATION_EDITOR_SCOPE} from '../../../../constants';
import {KEYS} from '../../../../translation-keys';


// hack to inject decorator declarations
export interface QuestionTypeColumnChartComponent extends Translatable {}

@Component({
  selector: 'app-qa-question-column-chart',
  templateUrl: './question-type-column-chart.component.html',
  styleUrls: ['./question-type-bar-chart.component.css'],
  encapsulation: ViewEncapsulation.None
})
@Translatable({scope: TRANSLATION_EDITOR_SCOPE, keys: KEYS})
export class QuestionTypeColumnChartComponent implements OnInit {
  @Input() question: Questionnaire.Container;

  /**
   * Locale for questionnaire. Hardcoded to "de_DE" for now.
   */
  public locale = 'de_DE';

  /**
   * Default option for select2 component
   */
  public select2Opts = {width: '200px', placeholder: '...'};

  /**
   * List of available numeric variables
   */
  public variables: string[] = [];

  /**
   * Alignment options for the chart
   */
  public alignmentOptions = [
    {value: 'left', label: 'CHART_ALIGNMENT_LEFT'},
    {value: 'center', label: 'CHART_ALIGNMENT_CENTER'},
    {value: 'right', label: 'CHART_ALIGNMENT_RIGHT'}
  ];

  /**
   * Injects dependencies
   */
  public constructor(
    @Optional() private translationService: TranslationService,
    private questionnaireEditor: QuestionnaireEditorService,
    private conditions: QuestionnaireConditionService,
    private ref: ChangeDetectorRef,
  ) {
  }

  /**
   * Initializes numeric variables list
   */
  public ngOnInit() {
    const variables = [];
    const select = this.conditions.getSelectData(false);

    for (const variable of select.variables) {
      const container =
        this.conditions.getContainerForVariable(variable);
      if (container && container.format === 'numeric') {
        variables.push(variable);
      }
    }

    this.variables = variables;
  }

  /**
   * Returns the chart data object from question options
   */
  get chartData(): any {
    return this.question.options.columnChart;
  }

  /**
   * Changes position of an entry in the entries list
   */
  public onPositionChange(
    currentPosition: number,
    newPosition: number
  ) {
    const entries = this.chartData.entries;

    if (
      currentPosition >= entries.length
      || newPosition < 0
    ) {
      return;
    }

    entries.splice(
      newPosition, 0,
      entries.splice(currentPosition, 1)[0]
    );
    this.triggerChangeDetection();
  }

  /**
   * Adds a new entry to the chart
   */
  public onAddEntry() {
    this.chartData.entries.push({
      label: {[this.locale]: ''},
      variable: '',
      color: '#4285f4',
    });

    this.triggerChangeDetection();
  }

  /**
   * Deletes an entry from the chart
   */
  public onDeleteEntry(position: number) {
    this.questionnaireEditor.confirmDelete(() => {
      this.chartData.entries.splice(position, 1);
      this.triggerChangeDetection();
    });
  }

  /**
   * Triggers change detection
   */
  public triggerChangeDetection() {
    this.ref.detectChanges();
    this.ref.markForCheck();
  }
}
